module.exports = __webpack_public_path__ + "img/bus-empty.ea306683.svg";